module.exports = __webpack_public_path__ + "img/name.62c0278c.png";